import React, {useState} from "react";
import {Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import useStatisticsData from "../Statistics/useStatisticsData.js";
import {formatDateDE, formatNumber, GROUP_PALETTE} from "../Statistics/format.js";
import {formatDuration} from "./format.js";
import NutzungWidget from "./NutzungWidget.jsx";

const METRIKEN = [
    {key: "aktive_sekunden", label: "Aktive Zeit", format: formatDuration},
    {key: "aktionen", label: "Aktionen", format: formatNumber},
    {key: "nutzer", label: "Mitarbeiter", format: formatNumber},
];

/**
 * Verlaufsdiagramm der Nutzung über die Zeit - Flächendiagramm mit
 * umschaltbarer Kennzahl, gleicher Aufbau wie RevenueTrendChart aus der
 * Verkaufsstatistik.
 */
export default function NutzungVerlaufChart({filters}) {
    const [metricKey, setMetricKey] = useState("aktive_sekunden");
    const {data, loading, error} = useStatisticsData("/nutzung/daten/verlauf", filters);
    const rows = Array.isArray(data) ? data : [];
    const metrik = METRIKEN.find((eintrag) => eintrag.key === metricKey);

    return (
        <NutzungWidget
            title="Verlauf"
            help="Tageswerte im gewählten Zeitraum und Filter."
            loading={loading}
            error={error}
            empty={!loading && !error && rows.length === 0}
            height={280}
            actions={
                <div className="btn-group btn-group-sm" role="group" aria-label="Kennzahl">
                    {METRIKEN.map((eintrag) => (
                        <button
                            key={eintrag.key}
                            type="button"
                            aria-pressed={metricKey === eintrag.key}
                            className={`btn ${metricKey === eintrag.key ? "btn-primary" : "btn-outline-secondary"}`}
                            onClick={() => setMetricKey(eintrag.key)}
                        >
                            {eintrag.label}
                        </button>
                    ))}
                </div>
            }
        >
            <ResponsiveContainer width="100%" height={280}>
                <AreaChart data={rows} margin={{top: 8, right: 12, left: 0, bottom: 0}}>
                    <defs>
                        <linearGradient id="nutzung-verlauf-fill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={GROUP_PALETTE[0]} stopOpacity={0.35} />
                            <stop offset="95%" stopColor={GROUP_PALETTE[0]} stopOpacity={0.03} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--bs-border-color, #dee2e6)" />
                    <XAxis dataKey="tag" tickFormatter={formatDateDE} tick={{fontSize: 12}} axisLine={false} tickLine={false} />
                    <YAxis
                        tickFormatter={(value) => (metricKey === "aktive_sekunden" ? formatDuration(value) : formatNumber(value))}
                        tick={{fontSize: 12}}
                        axisLine={false}
                        tickLine={false}
                        width={78}
                    />
                    <Tooltip formatter={(value) => [metrik.format(value), metrik.label]} labelFormatter={(label) => formatDateDE(label)} />
                    <Area type="monotone" dataKey={metricKey} stroke={GROUP_PALETTE[0]} strokeWidth={2} fill="url(#nutzung-verlauf-fill)" />
                </AreaChart>
            </ResponsiveContainer>
        </NutzungWidget>
    );
}
